// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"81b8bf70","442":"58cc3794","445":"763ca8bd","559":"763ca8bd"}[chunkId] + ".chunk.css";
};